module.exports = __webpack_public_path__ + "promises.svg?15cb929a0bd039ee7859b50e31f07c1b";


//////////////////
// WEBPACK FOOTER
// ./public/img/home/promises.svg
// module id = 553
// module chunks = 0